export type PlanTier = "free" | "pro" | "enterprise";

export type NavbarDropdownId = "org-switcher" | "help" | "language" | "user" | null;

export function getPlanTier(planName: string | undefined): PlanTier {
  if (!planName) return "free";

  const lower = planName.toLowerCase();

  if (lower.includes("enterprise") || lower.includes("business")) {
    return "enterprise";
  }

  if (lower.includes("pro") || lower.includes("growth") || lower.includes("professional")) {
    return "pro";
  }

  return "free";
}
